import React, {PureComponent} from 'react';

export default class ProfileRadiobox extends PureComponent{
	render(){
		const {id, label, currentProfileId, onChangeTypeProfile} = this.props;
		const el_id = `profile-${id}`;
		const flag = (id === currentProfileId) ? true: false;

		return (
			<div className="radiobox">
				<input type="radio" name="profile" value=""
					id={el_id}
					defaultChecked={flag}
					onChange = {() => onChangeTypeProfile(id)}
				/>
				<label htmlFor={el_id}>{label}</label>
			</div>
		)
	}
}